<template>
  <div class="fixed-center text-center">

    <SkeletonList />

    <q-btn
      color="secondary"
      style="width:200px;"
      @click="$router.push('/dashboard')"
    >Go back</q-btn>
  </div>
</template>

<script>
import SkeletonList from '@/components/Skeleton/SkeletonList.vue'

export default {
  name: 'Error404',
  components: {
    SkeletonList
  }
}
</script>
